import React from 'react';

const MissionStatement = () => {
  return (
    <section className="mission-section fade-in">
      <div className="mission-container">
        <div className="mission-card">
          <div className="mission-quote">
            <span className="quote-mark">"</span>
            <h2>We don't just deliver projects—we craft digital journeys that inspire, engage, and leave a lasting impression.</h2>
            <p className="mission-subtext">That's the Zentak difference.</p>
          </div>
          <a href="#contact" className="glass-btn glass-btn-primary">
            <span>Start Your Journey</span> →
          </a>
        </div>
      </div>
    </section>
  );
};

export default MissionStatement;
